import { render, staticRenderFns } from "./SmsCommunication.vue?vue&type=template&id=fe4866d6&"
import script from "./SmsCommunication.vue?vue&type=script&lang=js&"
export * from "./SmsCommunication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports